import {
    ActiveValueType,
    getAbsoluteSeverityColorLimits,
    getSeverityColorPalette
} from "pokal_api"
import { CategoryBar } from "@tremor/react"
import { getMarkerValue } from "./dashboard_data/LatestDataView"

interface ActiveValueTypeLatestIndicatorProps {
    valueType: ActiveValueType
    value?: number
}

function ActiveValueTypeLatestIndicator(
    props: ActiveValueTypeLatestIndicatorProps
) {
    return props.value !== undefined ? (
        <CategoryBar
            values={getAbsoluteSeverityColorLimits(props.valueType)}
            showLabels={false}
            colors={getSeverityColorPalette(props.valueType)}
            markerValue={getMarkerValue(props.value, props.valueType)}
        />
    ) : (
        <></>
    )
}

export default ActiveValueTypeLatestIndicator
